import { Splide, SplideSlide } from '@splidejs/react-splide';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import { useSelector } from 'react-redux';

import SmartImage from 'dpl/components/SmartImage';

export default function BreederProfilePhotosCarousel({ thumbnails, onClick }) {
  const splideRef = useRef(null);
  const breederFirstName = useSelector(({ server }) => server.breederFirstName);

  const peekable = thumbnails.length > 1;

  return (
    <div className="BreederProfilePhotosCarousel">
      <div className="container-xxl">
        <h3 className="font-serif font-24 lh-title mb6">
          {breederFirstName}’s photos
        </h3>
      </div>
      <Splide
        ref={splideRef}
        options={{
          arrows: false,
          drag: peekable,
          dragMinThreshold: 20,
          flickMaxPages: 1,
          flickPower: 300,
          gap: 16,
          keyboard: 'focused',
          padding: { left: 24, right: peekable ? 48 : 24 },
          pagination: false,
          perPage: 1,
          snap: true
        }}
      >
        {thumbnails.map(({ photo, count, category }, index) => (
          <SplideSlide key={photo.id}>
            <button
              type="button"
              className="BreederProfilePhotosCarousel__photo h-100 w-100"
              onClick={() => onClick(photo)}
            >
              <div
                className={classnames(
                  'aspect-ratio aspect-ratio--1x1 relative',
                  { nr6: peekable && index === thumbnails.length - 1 }
                )}
              >
                <div className="aspect-ratio--object">
                  <SmartImage
                    Tag="div"
                    className="w-100 h-100 cover bg-center"
                    wrapperOnlyClassName="br3 overflow-hidden"
                    src={photo.url}
                  />
                </div>
              </div>
              <div className="mt3 mt4-md">
                <p className="font-18 md:font-20 lh-title md:font-serif fw-medium mb1">
                  {category}
                </p>
                <p className="font-16 secondary">
                  {count} {count === 1 ? 'photo' : 'photos'}
                </p>
              </div>
            </button>
          </SplideSlide>
        ))}
      </Splide>
    </div>
  );
}

BreederProfilePhotosCarousel.propTypes = {
  onClick: PropTypes.func.isRequired,
  thumbnails: PropTypes.arrayOf(
    PropTypes.shape({
      category: PropTypes.string.isRequired,
      photo: PropTypes.shape({
        id: PropTypes.number.isRequired,
        url: PropTypes.string.isRequired
      }),
      count: PropTypes.number.isRequired
    })
  ).isRequired
};
